//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.15.10.0 (NJsonSchema v10.6.10.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { ApiBase } from './ApiBase';

export interface IClientsClient {
  /**
   * Get all clients
   * @return Success
   */
  getClients(): Promise<ClientDto[]>;

  /**
   * Create a client
   * @param body (optional)
   * @return Success
   */
  createClient(body?: ClientDto | null | undefined): Promise<ClientDto>;

  /**
   * Update a client
   * @param body (optional)
   * @return Success
   */
  updateClient(body?: ClientDto | null | undefined): Promise<ClientDto>;

  /**
   * Get all clients
   * @return Success
   */
  getClientsSkinny(): Promise<ClientDto[]>;

  /**
   * Get a client by id
   * @return Success
   */
  getClient(id: number): Promise<ClientDto>;

  /**
   * Delete a client
   * @return Success
   */
  deleteClient(id: number): Promise<void>;
}

export class ClientsClient extends ApiBase implements IClientsClient {
  private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
    super();
    this.http = http ? http : (window as any);
    this.baseUrl = this.getBaseUrl('', baseUrl);
  }

  /**
   * Get all clients
   * @return Success
   */
  getClients(): Promise<ClientDto[]> {
    let url_ = this.baseUrl + '/api/Clients';
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'text/plain',
      },
    };

    return this.transformOptions(options_)
      .then(transformedOptions_ => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetClients(_response);
      });
  }

  protected processGetClients(response: Response): Promise<ClientDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then(_responseText => {
        let result200: any = null;
        result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ClientDto[]);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then(_responseText => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<ClientDto[]>(null as any);
  }

  /**
   * Create a client
   * @param body (optional)
   * @return Success
   */
  createClient(body?: ClientDto | null | undefined): Promise<ClientDto> {
    let url_ = this.baseUrl + '/api/Clients';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: RequestInit = {
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json-patch+json',
        Accept: 'text/plain',
      },
    };

    return this.transformOptions(options_)
      .then(transformedOptions_ => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processCreateClient(_response);
      });
  }

  protected processCreateClient(response: Response): Promise<ClientDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then(_responseText => {
        let result200: any = null;
        result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ClientDto);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then(_responseText => {
        let result400: any = null;
        result400 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as string);
        return throwException('Bad Request', status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then(_responseText => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<ClientDto>(null as any);
  }

  /**
   * Update a client
   * @param body (optional)
   * @return Success
   */
  updateClient(body?: ClientDto | null | undefined): Promise<ClientDto> {
    let url_ = this.baseUrl + '/api/Clients';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: RequestInit = {
      body: content_,
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json-patch+json',
        Accept: 'text/plain',
      },
    };

    return this.transformOptions(options_)
      .then(transformedOptions_ => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processUpdateClient(_response);
      });
  }

  protected processUpdateClient(response: Response): Promise<ClientDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then(_responseText => {
        let result200: any = null;
        result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ClientDto);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then(_responseText => {
        let result400: any = null;
        result400 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as string);
        return throwException('Bad Request', status, _responseText, _headers, result400);
      });
    } else if (status === 404) {
      return response.text().then(_responseText => {
        let result404: any = null;
        result404 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as string);
        return throwException('Not Found', status, _responseText, _headers, result404);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then(_responseText => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<ClientDto>(null as any);
  }

  /**
   * Get all clients
   * @return Success
   */
  getClientsSkinny(): Promise<ClientDto[]> {
    let url_ = this.baseUrl + '/api/Clients/Skinny';
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'text/plain',
      },
    };

    return this.transformOptions(options_)
      .then(transformedOptions_ => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetClientsSkinny(_response);
      });
  }

  protected processGetClientsSkinny(response: Response): Promise<ClientDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then(_responseText => {
        let result200: any = null;
        result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ClientDto[]);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then(_responseText => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<ClientDto[]>(null as any);
  }

  /**
   * Get a client by id
   * @return Success
   */
  getClient(id: number): Promise<ClientDto> {
    let url_ = this.baseUrl + '/api/Clients/{id}';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'text/plain',
      },
    };

    return this.transformOptions(options_)
      .then(transformedOptions_ => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetClient(_response);
      });
  }

  protected processGetClient(response: Response): Promise<ClientDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then(_responseText => {
        let result200: any = null;
        result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ClientDto);
        return result200;
      });
    } else if (status === 404) {
      return response.text().then(_responseText => {
        let result404: any = null;
        result404 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('Not Found', status, _responseText, _headers, result404);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then(_responseText => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<ClientDto>(null as any);
  }

  /**
   * Delete a client
   * @return Success
   */
  deleteClient(id: number): Promise<void> {
    let url_ = this.baseUrl + '/api/Clients/{id}';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'DELETE',
      headers: {},
    };

    return this.transformOptions(options_)
      .then(transformedOptions_ => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processDeleteClient(_response);
      });
  }

  protected processDeleteClient(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then(_responseText => {
        return;
      });
    } else if (status === 404) {
      return response.text().then(_responseText => {
        let result404: any = null;
        result404 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as string);
        return throwException('Not Found', status, _responseText, _headers, result404);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then(_responseText => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<void>(null as any);
  }
}

export interface IEmployeesClient {
  /**
   * Get all employees
   * @return Success
   */
  getEmployees(): Promise<EmployeeDto[]>;

  /**
   * Create an employee
   * @param body (optional)
   * @return Success
   */
  createEmployee(body?: EmployeeDto | null | undefined): Promise<EmployeeDto>;

  /**
   * Update an employee
   * @param body (optional)
   * @return Success
   */
  updateEmployee(body?: EmployeeDto | null | undefined): Promise<EmployeeDto>;

  /**
   * Get all valid proxy user options
   * @return Success
   */
  getProxyUserOptions(): Promise<EmployeeDto[]>;

  /**
   * Get all employees who report to you
   * @return Success
   */
  getReportingEmployees(): Promise<EmployeeDto[]>;

  /**
   * Get an employee by id
   * @return Success
   */
  getEmployee(id: number): Promise<EmployeeDto>;

  /**
   * Delete an Employee
   * @return Success
   */
  deleteEmployee(id: number): Promise<void>;

  /**
   * Checks if user is a manager
   * @return Success
   */
  isManager(): Promise<boolean>;
}

export class EmployeesClient extends ApiBase implements IEmployeesClient {
  private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
    super();
    this.http = http ? http : (window as any);
    this.baseUrl = this.getBaseUrl('', baseUrl);
  }

  /**
   * Get all employees
   * @return Success
   */
  getEmployees(): Promise<EmployeeDto[]> {
    let url_ = this.baseUrl + '/api/Employees';
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'text/plain',
      },
    };

    return this.transformOptions(options_)
      .then(transformedOptions_ => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetEmployees(_response);
      });
  }

  protected processGetEmployees(response: Response): Promise<EmployeeDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then(_responseText => {
        let result200: any = null;
        result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as EmployeeDto[]);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then(_responseText => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<EmployeeDto[]>(null as any);
  }

  /**
   * Create an employee
   * @param body (optional)
   * @return Success
   */
  createEmployee(body?: EmployeeDto | null | undefined): Promise<EmployeeDto> {
    let url_ = this.baseUrl + '/api/Employees';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: RequestInit = {
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json-patch+json',
        Accept: 'text/plain',
      },
    };

    return this.transformOptions(options_)
      .then(transformedOptions_ => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processCreateEmployee(_response);
      });
  }

  protected processCreateEmployee(response: Response): Promise<EmployeeDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then(_responseText => {
        let result200: any = null;
        result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as EmployeeDto);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then(_responseText => {
        let result400: any = null;
        result400 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as string);
        return throwException('Bad Request', status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then(_responseText => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<EmployeeDto>(null as any);
  }

  /**
   * Update an employee
   * @param body (optional)
   * @return Success
   */
  updateEmployee(body?: EmployeeDto | null | undefined): Promise<EmployeeDto> {
    let url_ = this.baseUrl + '/api/Employees';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: RequestInit = {
      body: content_,
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json-patch+json',
        Accept: 'text/plain',
      },
    };

    return this.transformOptions(options_)
      .then(transformedOptions_ => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processUpdateEmployee(_response);
      });
  }

  protected processUpdateEmployee(response: Response): Promise<EmployeeDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then(_responseText => {
        let result200: any = null;
        result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as EmployeeDto);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then(_responseText => {
        let result400: any = null;
        result400 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as string);
        return throwException('Bad Request', status, _responseText, _headers, result400);
      });
    } else if (status === 404) {
      return response.text().then(_responseText => {
        let result404: any = null;
        result404 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as string);
        return throwException('Not Found', status, _responseText, _headers, result404);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then(_responseText => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<EmployeeDto>(null as any);
  }

  /**
   * Get all valid proxy user options
   * @return Success
   */
  getProxyUserOptions(): Promise<EmployeeDto[]> {
    let url_ = this.baseUrl + '/api/Employees/proxyUserOptions';
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'text/plain',
      },
    };

    return this.transformOptions(options_)
      .then(transformedOptions_ => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetProxyUserOptions(_response);
      });
  }

  protected processGetProxyUserOptions(response: Response): Promise<EmployeeDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then(_responseText => {
        let result200: any = null;
        result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as EmployeeDto[]);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then(_responseText => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<EmployeeDto[]>(null as any);
  }

  /**
   * Get all employees who report to you
   * @return Success
   */
  getReportingEmployees(): Promise<EmployeeDto[]> {
    let url_ = this.baseUrl + '/api/Employees/reporting';
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'text/plain',
      },
    };

    return this.transformOptions(options_)
      .then(transformedOptions_ => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetReportingEmployees(_response);
      });
  }

  protected processGetReportingEmployees(response: Response): Promise<EmployeeDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then(_responseText => {
        let result200: any = null;
        result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as EmployeeDto[]);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then(_responseText => {
        let result400: any = null;
        result400 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as string);
        return throwException('Bad Request', status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then(_responseText => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<EmployeeDto[]>(null as any);
  }

  /**
   * Get an employee by id
   * @return Success
   */
  getEmployee(id: number): Promise<EmployeeDto> {
    let url_ = this.baseUrl + '/api/Employees/{id}';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'text/plain',
      },
    };

    return this.transformOptions(options_)
      .then(transformedOptions_ => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetEmployee(_response);
      });
  }

  protected processGetEmployee(response: Response): Promise<EmployeeDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then(_responseText => {
        let result200: any = null;
        result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as EmployeeDto);
        return result200;
      });
    } else if (status === 404) {
      return response.text().then(_responseText => {
        let result404: any = null;
        result404 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails);
        return throwException('Not Found', status, _responseText, _headers, result404);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then(_responseText => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<EmployeeDto>(null as any);
  }

  /**
   * Delete an Employee
   * @return Success
   */
  deleteEmployee(id: number): Promise<void> {
    let url_ = this.baseUrl + '/api/Employees/{id}';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'DELETE',
      headers: {},
    };

    return this.transformOptions(options_)
      .then(transformedOptions_ => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processDeleteEmployee(_response);
      });
  }

  protected processDeleteEmployee(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then(_responseText => {
        return;
      });
    } else if (status === 404) {
      return response.text().then(_responseText => {
        let result404: any = null;
        result404 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as string);
        return throwException('Not Found', status, _responseText, _headers, result404);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then(_responseText => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<void>(null as any);
  }

  /**
   * Checks if user is a manager
   * @return Success
   */
  isManager(): Promise<boolean> {
    let url_ = this.baseUrl + '/api/Employees/manager';
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'text/plain',
      },
    };

    return this.transformOptions(options_)
      .then(transformedOptions_ => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processIsManager(_response);
      });
  }

  protected processIsManager(response: Response): Promise<boolean> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then(_responseText => {
        let result200: any = null;
        result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as boolean);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then(_responseText => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<boolean>(null as any);
  }
}

export interface IManagerProxyClient {
  /**
   * Gets Proxies that the requesting user has permission to see
   * @return Success
   */
  getManagerProxies(): Promise<ManagerProxyDto[]>;

  /**
   * Create a Manager Proxy
   * @param body (optional)
   * @return Success
   */
  createManagerProxy(body?: ManagerProxyDto | null | undefined): Promise<ManagerProxyDto>;

  /**
   * Delete a Manager Proxy
   * @return Success
   */
  deleteManagerProxy(managerProxyID: number): Promise<void>;
}

export class ManagerProxyClient extends ApiBase implements IManagerProxyClient {
  private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
    super();
    this.http = http ? http : (window as any);
    this.baseUrl = this.getBaseUrl('', baseUrl);
  }

  /**
   * Gets Proxies that the requesting user has permission to see
   * @return Success
   */
  getManagerProxies(): Promise<ManagerProxyDto[]> {
    let url_ = this.baseUrl + '/api/ManagerProxy';
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'text/plain',
      },
    };

    return this.transformOptions(options_)
      .then(transformedOptions_ => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetManagerProxies(_response);
      });
  }

  protected processGetManagerProxies(response: Response): Promise<ManagerProxyDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then(_responseText => {
        let result200: any = null;
        result200 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ManagerProxyDto[]);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then(_responseText => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<ManagerProxyDto[]>(null as any);
  }

  /**
   * Create a Manager Proxy
   * @param body (optional)
   * @return Success
   */
  createManagerProxy(body?: ManagerProxyDto | null | undefined): Promise<ManagerProxyDto> {
    let url_ = this.baseUrl + '/api/ManagerProxy';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: RequestInit = {
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json-patch+json',
        Accept: 'text/plain',
      },
    };

    return this.transformOptions(options_)
      .then(transformedOptions_ => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processCreateManagerProxy(_response);
      });
  }

  protected processCreateManagerProxy(response: Response): Promise<ManagerProxyDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then(_responseText => {
        let result200: any = null;
        result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ManagerProxyDto);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then(_responseText => {
        let result400: any = null;
        result400 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as string);
        return throwException('Bad Request', status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then(_responseText => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<ManagerProxyDto>(null as any);
  }

  /**
   * Delete a Manager Proxy
   * @return Success
   */
  deleteManagerProxy(managerProxyID: number): Promise<void> {
    let url_ = this.baseUrl + '/api/ManagerProxy/{managerProxyID}';
    if (managerProxyID === undefined || managerProxyID === null)
      throw new Error("The parameter 'managerProxyID' must be defined.");
    url_ = url_.replace('{managerProxyID}', encodeURIComponent('' + managerProxyID));
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'DELETE',
      headers: {},
    };

    return this.transformOptions(options_)
      .then(transformedOptions_ => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processDeleteManagerProxy(_response);
      });
  }

  protected processDeleteManagerProxy(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then(_responseText => {
        return;
      });
    } else if (status === 400) {
      return response.text().then(_responseText => {
        let result400: any = null;
        result400 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as string);
        return throwException('Bad Request', status, _responseText, _headers, result400);
      });
    } else if (status === 404) {
      return response.text().then(_responseText => {
        let result404: any = null;
        result404 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as string);
        return throwException('Not Found', status, _responseText, _headers, result404);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then(_responseText => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<void>(null as any);
  }
}

export interface IPrioritiesClient {
  /**
   * Gets all Priorities
   * @return Success
   */
  getPriorities(): Promise<PriorityItemDto[]>;

  /**
   * Create a new Priority
   * @param body (optional)
   * @return Success
   */
  createPriority(body?: PriorityItemDto | null | undefined): Promise<PriorityItemDto>;

  /**
   * Update a Priority
   * @param body (optional)
   * @return Success
   */
  updatePriority(body?: PriorityItemDto | null | undefined): Promise<PriorityItemDto>;

  /**
   * Get all priorities assigned to a particular team
   * @param includeProxies (optional)
   * @param teamId (optional)
   * @param startDate (optional)
   * @param endDate (optional)
   * @param roleName (optional)
   * @return Success
   */
  getPrioritiesByTeam(
    includeProxies?: boolean | undefined,
    teamId?: number | null | undefined,
    startDate?: Date | null | undefined,
    endDate?: Date | null | undefined,
    roleName?: string[] | null | undefined
  ): Promise<EmployeeWithPrioritiesDto[]>;

  /**
   * Checks permissions
   * @param employeeId (optional)
   * @return Success
   */
  hasPermissionToEdit(employeeId?: number | undefined): Promise<boolean>;

  /**
   * Reorder an employee's priorities
   * @param body (optional)
   * @return Success
   */
  reorderPriorities(employeeId: number, body?: PriorityItemDto[] | null | undefined): Promise<void>;

  /**
   * Delete a priority
   * @return Success
   */
  deletePriority(id: number): Promise<void>;
}

export class PrioritiesClient extends ApiBase implements IPrioritiesClient {
  private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
    super();
    this.http = http ? http : (window as any);
    this.baseUrl = this.getBaseUrl('', baseUrl);
  }

  /**
   * Gets all Priorities
   * @return Success
   */
  getPriorities(): Promise<PriorityItemDto[]> {
    let url_ = this.baseUrl + '/api/Priorities';
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'text/plain',
      },
    };

    return this.transformOptions(options_)
      .then(transformedOptions_ => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetPriorities(_response);
      });
  }

  protected processGetPriorities(response: Response): Promise<PriorityItemDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then(_responseText => {
        let result200: any = null;
        result200 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as PriorityItemDto[]);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then(_responseText => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<PriorityItemDto[]>(null as any);
  }

  /**
   * Create a new Priority
   * @param body (optional)
   * @return Success
   */
  createPriority(body?: PriorityItemDto | null | undefined): Promise<PriorityItemDto> {
    let url_ = this.baseUrl + '/api/Priorities';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: RequestInit = {
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json-patch+json',
        Accept: 'text/plain',
      },
    };

    return this.transformOptions(options_)
      .then(transformedOptions_ => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processCreatePriority(_response);
      });
  }

  protected processCreatePriority(response: Response): Promise<PriorityItemDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then(_responseText => {
        let result200: any = null;
        result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as PriorityItemDto);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then(_responseText => {
        let result400: any = null;
        result400 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as string);
        return throwException('Bad Request', status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then(_responseText => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<PriorityItemDto>(null as any);
  }

  /**
   * Update a Priority
   * @param body (optional)
   * @return Success
   */
  updatePriority(body?: PriorityItemDto | null | undefined): Promise<PriorityItemDto> {
    let url_ = this.baseUrl + '/api/Priorities';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: RequestInit = {
      body: content_,
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json-patch+json',
        Accept: 'text/plain',
      },
    };

    return this.transformOptions(options_)
      .then(transformedOptions_ => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processUpdatePriority(_response);
      });
  }

  protected processUpdatePriority(response: Response): Promise<PriorityItemDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then(_responseText => {
        let result200: any = null;
        result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as PriorityItemDto);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then(_responseText => {
        let result400: any = null;
        result400 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as string);
        return throwException('Bad Request', status, _responseText, _headers, result400);
      });
    } else if (status === 404) {
      return response.text().then(_responseText => {
        let result404: any = null;
        result404 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as string);
        return throwException('Not Found', status, _responseText, _headers, result404);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then(_responseText => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<PriorityItemDto>(null as any);
  }

  /**
   * Get all priorities assigned to a particular team
   * @param includeProxies (optional)
   * @param teamId (optional)
   * @param startDate (optional)
   * @param endDate (optional)
   * @param roleName (optional)
   * @return Success
   */
  getPrioritiesByTeam(
    includeProxies?: boolean | undefined,
    teamId?: number | null | undefined,
    startDate?: Date | null | undefined,
    endDate?: Date | null | undefined,
    roleName?: string[] | null | undefined
  ): Promise<EmployeeWithPrioritiesDto[]> {
    let url_ = this.baseUrl + '/api/Priorities/team?';
    if (includeProxies === null) throw new Error("The parameter 'includeProxies' cannot be null.");
    else if (includeProxies !== undefined) url_ += 'includeProxies=' + encodeURIComponent('' + includeProxies) + '&';
    if (teamId !== undefined && teamId !== null) url_ += 'teamId=' + encodeURIComponent('' + teamId) + '&';
    if (startDate !== undefined && startDate !== null)
      url_ += 'startDate=' + encodeURIComponent(startDate ? '' + startDate.toISOString() : '') + '&';
    if (endDate !== undefined && endDate !== null)
      url_ += 'endDate=' + encodeURIComponent(endDate ? '' + endDate.toISOString() : '') + '&';
    if (roleName !== undefined && roleName !== null)
      roleName &&
        roleName.forEach(item => {
          url_ += 'roleName=' + encodeURIComponent('' + item) + '&';
        });
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'text/plain',
      },
    };

    return this.transformOptions(options_)
      .then(transformedOptions_ => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetPrioritiesByTeam(_response);
      });
  }

  protected processGetPrioritiesByTeam(response: Response): Promise<EmployeeWithPrioritiesDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then(_responseText => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as EmployeeWithPrioritiesDto[]);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then(_responseText => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<EmployeeWithPrioritiesDto[]>(null as any);
  }

  /**
   * Checks permissions
   * @param employeeId (optional)
   * @return Success
   */
  hasPermissionToEdit(employeeId?: number | undefined): Promise<boolean> {
    let url_ = this.baseUrl + '/api/Priorities/permission?';
    if (employeeId === null) throw new Error("The parameter 'employeeId' cannot be null.");
    else if (employeeId !== undefined) url_ += 'employeeId=' + encodeURIComponent('' + employeeId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'text/plain',
      },
    };

    return this.transformOptions(options_)
      .then(transformedOptions_ => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processHasPermissionToEdit(_response);
      });
  }

  protected processHasPermissionToEdit(response: Response): Promise<boolean> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then(_responseText => {
        let result200: any = null;
        result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as boolean);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then(_responseText => {
        let result400: any = null;
        result400 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as string);
        return throwException('Bad Request', status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then(_responseText => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<boolean>(null as any);
  }

  /**
   * Reorder an employee's priorities
   * @param body (optional)
   * @return Success
   */
  reorderPriorities(employeeId: number, body?: PriorityItemDto[] | null | undefined): Promise<void> {
    let url_ = this.baseUrl + '/api/Priorities/{employeeId}';
    if (employeeId === undefined || employeeId === null) throw new Error("The parameter 'employeeId' must be defined.");
    url_ = url_.replace('{employeeId}', encodeURIComponent('' + employeeId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: RequestInit = {
      body: content_,
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json-patch+json',
      },
    };

    return this.transformOptions(options_)
      .then(transformedOptions_ => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processReorderPriorities(_response);
      });
  }

  protected processReorderPriorities(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then(_responseText => {
        return;
      });
    } else if (status === 400) {
      return response.text().then(_responseText => {
        let result400: any = null;
        result400 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as string);
        return throwException('Bad Request', status, _responseText, _headers, result400);
      });
    } else if (status === 404) {
      return response.text().then(_responseText => {
        let result404: any = null;
        result404 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as string);
        return throwException('Not Found', status, _responseText, _headers, result404);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then(_responseText => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<void>(null as any);
  }

  /**
   * Delete a priority
   * @return Success
   */
  deletePriority(id: number): Promise<void> {
    let url_ = this.baseUrl + '/api/Priorities/{id}';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'DELETE',
      headers: {},
    };

    return this.transformOptions(options_)
      .then(transformedOptions_ => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processDeletePriority(_response);
      });
  }

  protected processDeletePriority(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then(_responseText => {
        return;
      });
    } else if (status === 400) {
      return response.text().then(_responseText => {
        let result400: any = null;
        result400 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as string);
        return throwException('Bad Request', status, _responseText, _headers, result400);
      });
    } else if (status === 404) {
      return response.text().then(_responseText => {
        let result404: any = null;
        result404 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as string);
        return throwException('Not Found', status, _responseText, _headers, result404);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then(_responseText => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<void>(null as any);
  }
}

export interface IProjectsClient {
  /**
   * Gets all Projects
   * @return Success
   */
  getProjects(): Promise<ProjectDto[]>;

  /**
   * Create a new Project
   * @param body (optional)
   * @return Success
   */
  createProject(body?: ProjectDto | null | undefined): Promise<ProjectDto>;

  /**
   * Update an existing Project
   * @param body (optional)
   * @return Success
   */
  updateProject(body?: ProjectDto | null | undefined): Promise<ProjectDto>;

  /**
   * Gets all Clients Projects
   * @param includeProxies (optional)
   * @param teamManagerId (optional)
   * @param roleName (optional)
   * @return Success
   */
  getProjectPriorities(
    includeProxies?: boolean | undefined,
    teamManagerId?: number | null | undefined,
    roleName?: string[] | null | undefined
  ): Promise<ProjectPrioritiesDto[]>;

  /**
   * Get all projects associated with a client
   * @param id client id
   * @return Success
   */
  getProjectsByClient(id: number): Promise<ProjectDto[]>;

  /**
   * Delete a Project
   * @return Success
   */
  deleteProject(id: number): Promise<void>;
}

export class ProjectsClient extends ApiBase implements IProjectsClient {
  private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
    super();
    this.http = http ? http : (window as any);
    this.baseUrl = this.getBaseUrl('', baseUrl);
  }

  /**
   * Gets all Projects
   * @return Success
   */
  getProjects(): Promise<ProjectDto[]> {
    let url_ = this.baseUrl + '/api/Projects';
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'text/plain',
      },
    };

    return this.transformOptions(options_)
      .then(transformedOptions_ => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetProjects(_response);
      });
  }

  protected processGetProjects(response: Response): Promise<ProjectDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then(_responseText => {
        let result200: any = null;
        result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProjectDto[]);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then(_responseText => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<ProjectDto[]>(null as any);
  }

  /**
   * Create a new Project
   * @param body (optional)
   * @return Success
   */
  createProject(body?: ProjectDto | null | undefined): Promise<ProjectDto> {
    let url_ = this.baseUrl + '/api/Projects';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: RequestInit = {
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json-patch+json',
        Accept: 'text/plain',
      },
    };

    return this.transformOptions(options_)
      .then(transformedOptions_ => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processCreateProject(_response);
      });
  }

  protected processCreateProject(response: Response): Promise<ProjectDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then(_responseText => {
        let result200: any = null;
        result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProjectDto);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then(_responseText => {
        let result400: any = null;
        result400 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as string);
        return throwException('Bad Request', status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then(_responseText => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<ProjectDto>(null as any);
  }

  /**
   * Update an existing Project
   * @param body (optional)
   * @return Success
   */
  updateProject(body?: ProjectDto | null | undefined): Promise<ProjectDto> {
    let url_ = this.baseUrl + '/api/Projects';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: RequestInit = {
      body: content_,
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json-patch+json',
        Accept: 'text/plain',
      },
    };

    return this.transformOptions(options_)
      .then(transformedOptions_ => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processUpdateProject(_response);
      });
  }

  protected processUpdateProject(response: Response): Promise<ProjectDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then(_responseText => {
        let result200: any = null;
        result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProjectDto);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then(_responseText => {
        let result400: any = null;
        result400 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as string);
        return throwException('Bad Request', status, _responseText, _headers, result400);
      });
    } else if (status === 404) {
      return response.text().then(_responseText => {
        let result404: any = null;
        result404 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as string);
        return throwException('Not Found', status, _responseText, _headers, result404);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then(_responseText => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<ProjectDto>(null as any);
  }

  /**
   * Gets all Clients Projects
   * @param includeProxies (optional)
   * @param teamManagerId (optional)
   * @param roleName (optional)
   * @return Success
   */
  getProjectPriorities(
    includeProxies?: boolean | undefined,
    teamManagerId?: number | null | undefined,
    roleName?: string[] | null | undefined
  ): Promise<ProjectPrioritiesDto[]> {
    let url_ = this.baseUrl + '/api/Projects/getProjectsWithPriorities?';
    if (includeProxies === null) throw new Error("The parameter 'includeProxies' cannot be null.");
    else if (includeProxies !== undefined) url_ += 'includeProxies=' + encodeURIComponent('' + includeProxies) + '&';
    if (teamManagerId !== undefined && teamManagerId !== null)
      url_ += 'teamManagerId=' + encodeURIComponent('' + teamManagerId) + '&';
    if (roleName !== undefined && roleName !== null)
      roleName &&
        roleName.forEach(item => {
          url_ += 'roleName=' + encodeURIComponent('' + item) + '&';
        });
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'text/plain',
      },
    };

    return this.transformOptions(options_)
      .then(transformedOptions_ => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetProjectPriorities(_response);
      });
  }

  protected processGetProjectPriorities(response: Response): Promise<ProjectPrioritiesDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then(_responseText => {
        let result200: any = null;
        result200 =
          _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProjectPrioritiesDto[]);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then(_responseText => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<ProjectPrioritiesDto[]>(null as any);
  }

  /**
   * Get all projects associated with a client
   * @param id client id
   * @return Success
   */
  getProjectsByClient(id: number): Promise<ProjectDto[]> {
    let url_ = this.baseUrl + '/api/Projects/Client {id}';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'text/plain',
      },
    };

    return this.transformOptions(options_)
      .then(transformedOptions_ => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetProjectsByClient(_response);
      });
  }

  protected processGetProjectsByClient(response: Response): Promise<ProjectDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then(_responseText => {
        let result200: any = null;
        result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as ProjectDto[]);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then(_responseText => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<ProjectDto[]>(null as any);
  }

  /**
   * Delete a Project
   * @return Success
   */
  deleteProject(id: number): Promise<void> {
    let url_ = this.baseUrl + '/api/Projects/{id}';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'DELETE',
      headers: {},
    };

    return this.transformOptions(options_)
      .then(transformedOptions_ => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processDeleteProject(_response);
      });
  }

  protected processDeleteProject(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then(_responseText => {
        return;
      });
    } else if (status === 404) {
      return response.text().then(_responseText => {
        let result404: any = null;
        result404 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as string);
        return throwException('Not Found', status, _responseText, _headers, result404);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then(_responseText => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<void>(null as any);
  }
}

export interface IRolesClient {
  /**
   * Get all roles
   * @return Success
   */
  getRoles(): Promise<RoleDto[]>;

  /**
   * Create a new role
   * @param body (optional)
   * @return Success
   */
  createRole(body?: RoleDto | null | undefined): Promise<RoleDto>;

  /**
   * Get role by roleID
   * @return Success
   */
  getRoleById(roleID: number): Promise<Role>;

  /**
   * Delete a role
   * @return Success
   */
  deleteRole(id: number): Promise<void>;
}

export class RolesClient extends ApiBase implements IRolesClient {
  private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
    super();
    this.http = http ? http : (window as any);
    this.baseUrl = this.getBaseUrl('', baseUrl);
  }

  /**
   * Get all roles
   * @return Success
   */
  getRoles(): Promise<RoleDto[]> {
    let url_ = this.baseUrl + '/api/Roles';
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'text/plain',
      },
    };

    return this.transformOptions(options_)
      .then(transformedOptions_ => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetRoles(_response);
      });
  }

  protected processGetRoles(response: Response): Promise<RoleDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then(_responseText => {
        let result200: any = null;
        result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as RoleDto[]);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then(_responseText => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<RoleDto[]>(null as any);
  }

  /**
   * Create a new role
   * @param body (optional)
   * @return Success
   */
  createRole(body?: RoleDto | null | undefined): Promise<RoleDto> {
    let url_ = this.baseUrl + '/api/Roles';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: RequestInit = {
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json-patch+json',
        Accept: 'text/plain',
      },
    };

    return this.transformOptions(options_)
      .then(transformedOptions_ => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processCreateRole(_response);
      });
  }

  protected processCreateRole(response: Response): Promise<RoleDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then(_responseText => {
        let result200: any = null;
        result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as RoleDto);
        return result200;
      });
    } else if (status === 400) {
      return response.text().then(_responseText => {
        let result400: any = null;
        result400 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as string);
        return throwException('Bad Request', status, _responseText, _headers, result400);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then(_responseText => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<RoleDto>(null as any);
  }

  /**
   * Get role by roleID
   * @return Success
   */
  getRoleById(roleID: number): Promise<Role> {
    let url_ = this.baseUrl + '/api/Roles/{roleID}';
    if (roleID === undefined || roleID === null) throw new Error("The parameter 'roleID' must be defined.");
    url_ = url_.replace('{roleID}', encodeURIComponent('' + roleID));
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'text/plain',
      },
    };

    return this.transformOptions(options_)
      .then(transformedOptions_ => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetRoleById(_response);
      });
  }

  protected processGetRoleById(response: Response): Promise<Role> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then(_responseText => {
        let result200: any = null;
        result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as Role);
        return result200;
      });
    } else if (status === 404) {
      return response.text().then(_responseText => {
        let result404: any = null;
        result404 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as string);
        return throwException('Not Found', status, _responseText, _headers, result404);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then(_responseText => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<Role>(null as any);
  }

  /**
   * Delete a role
   * @return Success
   */
  deleteRole(id: number): Promise<void> {
    let url_ = this.baseUrl + '/api/Roles/{id}';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'DELETE',
      headers: {},
    };

    return this.transformOptions(options_)
      .then(transformedOptions_ => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processDeleteRole(_response);
      });
  }

  protected processDeleteRole(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then(_responseText => {
        return;
      });
    } else if (status === 404) {
      return response.text().then(_responseText => {
        let result404: any = null;
        result404 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as string);
        return throwException('Not Found', status, _responseText, _headers, result404);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then(_responseText => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<void>(null as any);
  }
}

export interface ITeamsClient {
  /**
   * Get all teams
   * @return Success
   */
  getTeams(): Promise<TeamDto[]>;
}

export class TeamsClient extends ApiBase implements ITeamsClient {
  private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
    super();
    this.http = http ? http : (window as any);
    this.baseUrl = this.getBaseUrl('', baseUrl);
  }

  /**
   * Get all teams
   * @return Success
   */
  getTeams(): Promise<TeamDto[]> {
    let url_ = this.baseUrl + '/api/Teams';
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'text/plain',
      },
    };

    return this.transformOptions(options_)
      .then(transformedOptions_ => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetTeams(_response);
      });
  }

  protected processGetTeams(response: Response): Promise<TeamDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then(_responseText => {
        let result200: any = null;
        result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as TeamDto[]);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then(_responseText => {
        return throwException('An unexpected server error occurred.', status, _responseText, _headers);
      });
    }
    return Promise.resolve<TeamDto[]>(null as any);
  }
}

export interface EmployeeDto {
  id: number;
  firstName: string | null;
  lastName: string | null;
  email: string | null;
  managerId: number | null;
  teamName: string | null;
  managerTeamName: string | null;
  totalUtilisation: number;
  roleId: number | null;
  roleName: string | null;
  profileLink: string | null;
}

export interface ProjectDto {
  id: number;
  clientID: number | null;
  name: string | null;
  description: string | null;
  isBillable: boolean | null;
  isActive: boolean | null;
  kCode: number | null;
  clientName: string | null;
  employees: EmployeeDto[] | null;
}

export interface ClientDto {
  id: number;
  name: string | null;
  projects: ProjectDto[] | null;
}

export interface ProblemDetails {
  type: string | null;
  title: string | null;
  status: number | null;
  detail: string | null;
  instance: string | null;
}

export interface ManagerProxyDto {
  managerProxyId: number;
  managerEmployeeId: number;
  proxyEmployeeId: number;
  managerName: string | null;
  proxyEmployeeName: string | null;
  endDate: Date | null;
}

export interface PriorityItemDto {
  id: number;
  employeeID: number;
  projectId: number;
  order: number;
  status: string | null;
  utilisation: number;
  description: string | null;
  startDate: Date;
  endDate: Date;
  projectName: string | null;
  clientName: string | null;
  employee: EmployeeDto | null;
  project: ProjectDto | null;
  createdBy: string | null;
  updatedBy: string | null;
  createdAt: Date;
  updatedAt: Date;
}

export interface EmployeeWithPrioritiesDto {
  id: number;
  firstName: string | null;
  lastName: string | null;
  email: string | null;
  managerId: number | null;
  roleName: string | null;
  teamName: string | null;
  currentUtilisation: number;
  priorities: PriorityItemDto[] | null;
  profileLink: string | null;
}

export interface ProjectPrioritiesDto {
  id: number;
  clientID: number | null;
  name: string | null;
  description: string | null;
  isBillable: boolean | null;
  isActive: boolean | null;
  kCode: number | null;
  clientName: string | null;
  priorities: PriorityItemDto[] | null;
}

export interface RoleDto {
  roleId: number;
  name: string | null;
}

export interface Role {
  createdAt: Date;
  createdBy: string;
  updatedAt: Date;
  updatedBy: string;
  deletedAt: Date | null;
  roleId: number;
  name: string;
}

export interface TeamDto {
  managerId: number;
  teamName: string | null;
  managerName: string | null;
}

export class SwaggerException extends Error {
  message: string;
  status: number;
  response: string;
  headers: { [key: string]: any };
  result: any;

  constructor(message: string, status: number, response: string, headers: { [key: string]: any }, result: any) {
    super();

    this.message = message;
    this.status = status;
    this.response = response;
    this.headers = headers;
    this.result = result;
  }

  protected isSwaggerException = true;

  static isSwaggerException(obj: any): obj is SwaggerException {
    return obj.isSwaggerException === true;
  }
}

function throwException(
  message: string,
  status: number,
  response: string,
  headers: { [key: string]: any },
  result?: any
): any {
  if (result !== null && result !== undefined) throw result;
  else throw new SwaggerException(message, status, response, headers, null);
}
